"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const quickShip_1 = require("../../../app/dist/quickShip");
exports.toolDef = {
    name: 'loom_quick_ship',
    description: 'Record already-done work as exactly one new DONE plan in a single call — the one-action way to leave a versioned-history entry for a fast fix/feature (roadmap history + actual_release key on done plans). Composes create-plan → start → complete-each-step → close-with-done-record. It does NOT implement code (do the work first, then quick-ship) and NEVER touches an existing plan — it always mints one fresh done plan. Target either an existing thread (thread_ulid) or mint a new one (newThread); pass exactly one. `description` is one line, or a short list where each entry becomes one done step — each must read as completed work. Pass `title` to give the plan a descriptive label for roadmap history (falls back to a generic `{thread} Plan` when omitted).',
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug.' },
            thread_ulid: {
                type: 'string',
                description: 'Stable th_ ULID of an existing thread to record into. Pass exactly one of thread_ulid or newThread.',
            },
            newThread: {
                type: 'object',
                description: 'Mint a new thread to hold the done plan. Pass exactly one of thread_ulid or newThread.',
                properties: {
                    slug: { type: 'string', description: 'New thread folder slug (kebab-case).' },
                    title: { type: 'string', description: 'Optional human title for the new thread.' },
                },
                required: ['slug'],
            },
            description: {
                oneOf: [{ type: 'string' }, { type: 'array', items: { type: 'string' } }],
                description: 'The completed work: one line (string), or a short list (array) where each entry becomes one DONE step. Each must read as completed work.',
            },
            title: {
                type: 'string',
                description: 'Optional descriptive plan title for roadmap history. Falls back to a generic `{thread} Plan` when omitted.',
            },
            notes: {
                type: 'string',
                description: 'Optional done-doc notes; defaults to a record derived from the description(s).',
            },
        },
        required: ['weave_slug', 'description'],
    },
};
async function handle(root, args) {
    // completeStep / closePlan flatMap over weave.threads, so a null weave must fail loud.
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const result = await (0, quickShip_1.quickShip)({
        weaveSlug: args['weave_slug'],
        threadUlid: args['thread_ulid'],
        newThread: args['newThread'],
        description: args['description'],
        title: args['title'],
        notes: args['notes'],
    }, { loadWeave: loadWeaveStrict, saveDoc: dist_1.saveDoc, saveDocs: dist_1.saveDocs, loadDoc: dist_1.loadDoc, fs, loomRoot: root });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
